<template>
    <div>
        <el-card>
            <template v-slot:header>
                <div class="clearfix">
                    <span style="font-weight: bold;"><i class="icon iconfont icon-duozhouqipaotu" style="font-weight: bold;margin-right: 5px;font-size: 20px;"></i>Genes Expression</span>
                    <el-button type="primary" icon="el-icon-download" size="small" @click="downloadChart('png')" 
                    style="float: right;background-color: #2C3E50;border: 1px solid #2C3E50;">Download PNG</el-button>
                    <el-button type="primary" icon="el-icon-download" size="small" @click="downloadChart('svg')" 
                    style="float: right;margin-right: 5px;background-color: #2C3E50;border: 1px solid #2C3E50;">Download SVG</el-button>
                </div>
            </template>
            <div class="container">
                <el-container>
                    <el-main>
                        <!-- <div id="bubblechart" style="width:100%;height:500px;"></div> -->
                        <div id="heatmap" style="width:100%;height:500px;"></div>
                    </el-main>
                </el-container>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            chartData: [],
            url: "http://183.175.59.4/devenhancer/", // 后端接口地址
            chartGraph: null,
            heatMapData: [] // 热图数据
        };
    },
    props: {
        species: {
            type: String,
            required: true
        },
        tissue: {
            type: [String, Array], // 现在它可以接受字符串或数组
            required: true
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.chartGraph = this.$echarts.init(document.getElementById('heatmap'));
            this.handleAnalysis();
        });
    },
    methods: {
      handleAnalysis() {
        // 发送请求获取后端数据
        const params = { Species: this.species, Tissue: this.tissue };
        this.$axios.get(this.url + "upexpr" + "/", { params })
          .then((response) => {
            // 对数据进行处理
            const res = response.data;

            const geneNames = []; // 存储基因名称
            const sampleNames = this.tissue; // 存储样本名称
            const heatMapData = []; // 存储气泡图数据

            res.forEach((row) => {
                const gene = row.SYMBOL;
                const sample = row.Tissue;
                let expression = row.Upex;

                if (!geneNames.includes(gene)) {
                geneNames.push(gene); // 添加基因名
                }

                if (!sampleNames.includes(sample)) {
                sampleNames.push(sample); // 添加样本名
                }

                expression = Math.log2(expression); // 转换为log2值
                expression = expression < 0 ? 0 : expression; // 将expression小于0的值转换为0

                heatMapData.push([gene, sample, expression]); // 添加气泡图数据
            });

            const maxExpression = Math.max(...heatMapData.map((item) => item[2])); // 获取expression的最大值

            const option = {
                tooltip: {
                    position: 'top',
                    formatter: function(params) {
                        return `Gene: ${params.value[0]}<br>Tissue: ${params.value[1]}<br>Expression: ${params.value[2]}`;
                    }
                },
                animation: false,
                grid: {
                    height: '70%',
                    top: '10%'
                },
                xAxis: {
                    type: 'category',
                    data: geneNames, // 设置基因名作为 x 轴标签数据
                    axisLabel: {
                        rotate: 45, // 旋转角度
                        fontSize: 10 // 字体大小
                    }
                },
                yAxis: {
                    type: 'category',
                    data: sampleNames , // 设置组织名作为 y 轴标签数据
                },
                visualMap: {
                    min: 0, // 最小值
                    max: maxExpression, // 最大值
                    calculable: true,
                    orient: 'horizontal',
                    left: 'center',
                    bottom: '0%',
                    inRange: {
                        color: [
                        '#313695', '#4575b4', '#74add1', '#abd9e9', '#e0f3f8',
                        '#ffffbf', '#fee090', '#fdae61', '#d73027', '#a50026'
                        ] // 设置颜色数组
                    },
                },
                series: [
                    {
                        name: 'Gene Expression',
                        type: 'heatmap', // 修改为 scatter 类型
                        symbolSize: function(value) {
                            return Math.sqrt(value[2]) * 3.5; // 设置气泡大小，可根据需要调整
                        },
                        data: heatMapData, // 修改为气泡图数据数组
                        label: {
                            show: false,
                        },
                        emphasis: {
                            itemStyle: {
                                borderColor: '#FF7070'
                            }
                        },
                    }
                ]
            };
            // 使用 echarts 关系图实例设置选项和数据
            this.chartGraph.setOption(option);
          })
          .catch((error) => {
            console.error(error);
            this.$message.error('Failed to fetch data.');
          });
      },
      // 下载图表
      downloadChart(format) {
        const options = {
          type: format,
          pixelRatio: 2,
          backgroundColor: '#fff',
        };
        const imageData = this.chartGraph.getDataURL(options);
        // 创建 a 标签并设置属性
        const link = document.createElement('a');
        link.href = imageData;
        link.download = `heatmap.${format}`;
        // 触发下载
        link.click();
      },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/comparison/Tpmexpr.vue